import type { CSSProperties, FC, MouseEventHandler } from 'react';
import { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import ProductCardPrice from '@/pages/Product/Menu/List/Card/Price';
import { getCDNAssets } from '@/utils';

import styles from './promationtip.module.less';

export type DynamicComboPromotionTipProps = {
  className?: string;
  style?: CSSProperties;
  price?: number;
};

const DynamicComboPromotionTip: FC<DynamicComboPromotionTipProps> = (props) => {
  const { className, style, price } = props;
  const [showTip, setShowTip] = useState(false);

  const closeTimer = useRef<ReturnType<typeof setTimeout>>();

  const onMaskClick = useCallback<MouseEventHandler<HTMLDivElement>>((e) => {
    e.stopPropagation();
    setShowTip(false);

    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
  }, []);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (price && price > 0) {
      timer = setTimeout(() => {
        setShowTip(true);

        if (closeTimer.current) {
          clearTimeout(closeTimer.current);
        }

        closeTimer.current = setTimeout(() => {
          setShowTip(false);
        }, 3000);
      }, 500);
    } else {
      setShowTip(false);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
      clearTimeout(closeTimer.current);
    };
  }, [price]);

  if (!showTip) {
    return null;
  }

  return (
    <Fragment>
      <div className={styles.mask} onClick={onMaskClick} />
      <div
        className={classNames(styles.wrapper, className)}
        style={{ backgroundImage: `url(${getCDNAssets('dc_combo_promotion_shadow_image.png')})`, ...style }}>
        <div className={styles.content}>
          <div className={styles.contentText}>搭配达人！</div>
          <div className={styles.contentPrice}>
            <span>省</span>&nbsp;
            {price && <ProductCardPrice originalPrice={price} />}
          </div>
        </div>
        <img className={styles.arrowImage} src={getCDNAssets('dc_combo_promotion_arrow_image.png')} />
        <img className={styles.fireworks} src={`${getCDNAssets('dc_combo_promotion_tips.gif')}?a=${Math.random()}`} />
      </div>
    </Fragment>
  );
};

export default DynamicComboPromotionTip;
